import idConstants from '../data/idConstants';
import i18next from 'i18next';

export const getConsumptionUnit = (rateLimitType) => {
  if (
    rateLimitType?.limitType?.replace(' ', '_') ===
    idConstants.pricing.apiCallLimitType
  ) {
    return i18next.t('DYNAMIC_FORM.PRICING_PLAN.REQUEST');
  }

  return rateLimitType?.limitTypeName || '';
};
